<template>
<div class="row m-0 mt-3">
  <div class="col-12 px-0 px-md-3">
    <div class="row m-0 align-items-center cursor" @click="goBack">
      <div class="col-auto pr-1">
        <ios-arrow-back-icon />
      </div>
      <div class="col-auto p-0 mb-1">
        Back
      </div>
    </div>
    <div v-if="isProductLoading" class="text-center">
      <grid-loader :loading="isProductLoading" :color="loaderColor" :size="loaderSize" class="d-inline-block" />
    </div>
    <div v-else>
      <div class="row m-0 my-3">
        <div class="col-md-8 col-lg-9 col-xl-8">
          <div class="card">
            <!-- <div class="row m-0">
              <div class="col-12 p-0 img_bg">
                <vue-image-slider :images="item.images" :intervalVal="30000" />
              </div>
            </div> -->
            <div class="row m-0">
              <div class="col-12 col-lg-6 col-xl-5 p-0 img_bg">
                <Slider :images="images" :height="40" v-if="images && images.length" />
                <img class="img-fluid" :src="item.thumbnail_url" alt=""  v-else-if="item.thumbnail_url">
                <!-- <Slider />
                <vue-image-slider :images="item.images" :intervalVal="30000" v-if="item.thumbnail_url" :height="100" :width="1200" /> -->
                <!-- <img class="img-fluid" :src="item.thumbnail_url" alt=""  v-if="item.thumbnail_url"> -->
                <img src="../image/placeholder-square.png" alt="" class="img-fluid" v-else>
              </div>
              <div class="col-12 col-lg-6 col-xl-7 p-3">
                <h4> {{ item.title }}</h4>
                <p> {{ item.description }} </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-3 col-xl-4 pr-0">
          <div class="card">
            <div class="row m-0" v-if="item.price">
              <div class="col-12 p-3">
                <div class="row m-0 align-items-center">
                  <div class="col-7 p-0">
                    <h2>R {{ totalPrice }}</h2>
                  </div>
                  <div class="col-5 p-0">
                    <div class="row m-0 justify-content-center align-items-center">
                      <div class="col text-right p-0" @click.stop="decrementValue">
                        <ios-remove-circle-outline-icon  />
                      </div>
                      <div class="col-4 px-1 text-center mb-2">
                        {{item_quantity}}
                      </div>
                      <div class="col text-left p-0" @click.stop="incrementValue">
                        <ios-add-circle-outline-icon  />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 px-3 pb-3">
                <select class="form-control hiddenSelect" v-model="variation" v-if="item.variations && item.variations[0].name !== ''">
                  <option value="" disabled selected>-- Please Select --</option>
                  <option :value="item">{{item.title}}</option>
                  <option v-for="(variation, index) in item.variations" :key="index" :value="variation">{{variation.name}} {{ variation.price - item.price | showPrice}}</option>
                </select>
                <span v-else>{{item.title}}</span>
                <!-- <span>{{ item.quantity }} left in stock</span> -->
                <button class="btn btn-outline w-100 mt-2" @click="addItem" ref="addToCart" :class="{disabled: item.variations && item.variations[0].name !== '' && variation === ''}" :disabled="item.variations && item.variations[0].name !== '' && variation === ''">
                  <span v-if="addingStatus == 'adding'">Adding...</span>
                  <span v-else-if="addingStatus == 'added'">Added</span>
                  <span v-else-if="item.soldOut">Sold Out</span>
                  <span v-else>Add to cart</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="row m-0" v-else>
              <div class="col-12 p-3">
                <div class="row m-0 align-items-center">
                  <div class="col-12 p-0">
                    <h2>Contact us</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GridLoader from 'vue-spinner/src/MoonLoader.vue'
// import VueImageSlider from 'vue-image-slider'
import Slider from '../components/product/Slider.vue'

export default {
  components: {
    GridLoader,
    // VueImageSlider,
    Slider
  },
  data () {
    return {
      loaderColor: '#5cb85c',
      loaderSize: '50px',
      addingStatus: 'done',
      item_quantity: 1,
      variation: '',
      timer: null
    }
  },
  metaInfo () {
    return {
      title: `${this.item.title}`,
      meta: [
        { name: 'description', content: `${this.item.description}` },
        {
          property: 'fb:app_id',
          content: '2744358572336800'
        },
        { property: 'og:title', content: `${this.item.title}` },
        {
          property: 'og:description',
          content: `${this.item.description}`
        },
        { property: 'og:type', content: 'website' },
        {
          property: 'og:image',
          content: `${this.item.thumbnail_url}`
        },
        {
          property: 'og:url',
          content: `https://${this.shopId}.thehoods.app/#/${this.shopId}/product/${this.item.id}`
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isProductLoading', 'products', 'shopId']),
    images () {
      if (this.item.images) {
        const ret = this.item.images
        ret.unshift(this.item.thumbnail_url)
        return ret
      }
      return []
    },
    item () {
      let id = parseInt(this.$route.params.id)
      if (this.products.length > 0) {
        let filterArr = this.products.filter((item) => {
          return item.id === id
        })
        if (filterArr.length > 0) {
          return filterArr[0]
        }
      }
      return {}
    },
    itemDetails () {
      return { item_id: this.item.id, item_name: this.item.title, item_category: this.item.category || 'uncategorized', price: this.item.price, images: this.item.images }
    },
    totalPrice () {
      if (typeof this.variation.name !== 'undefined') {
        return this.variation.price
      }
      return this.item.price
    }
  },
  filters: {
    showPrice (price) {
      if (price > 0) {
        return `(+ R ${price})`
      } else if (price < 0) {
        return `(- R ${-price})`
      } else {
        return ''
      }
    }
  },
  watch: {
    item () {
      this.$analytics.logEvent('view_item', { currency: 'ZAR', value: this.item.price, items: [this.itemDetails] })
    },
    itemDetails () {
      this.$meta().refresh()
    }
  },
  methods: {
    ...mapActions(['updateCart']),
    addItem () {
      this.addingStatus = 'adding'
      let oItem = Object.assign({}, this.item)
      if (typeof this.variation.name !== 'undefined') {
        oItem.title = oItem.title + ' (' + this.variation.name + ')'
        oItem.price = this.variation.price
        oItem.variation = this.variation.name
      }
      const order = {
        item: oItem,
        quantity: this.item_quantity,
        isAdd: true
      }
      // console.log(order);
      this.updateCart(order)
      console.log({ currency: 'ZAR', value: this.item.price * this.item_quantity, items: [{ ...this.itemDetails, quantity: this.item_quantity }] })
      this.$analytics.logEvent('add_to_cart', { currency: 'ZAR', value: this.item.price * this.item_quantity, items: [{ ...this.itemDetails, quantity: this.item_quantity }] })
      this.addingStatus = 'added'
      const ref = this.$refs.addToCart
      this.timer = setTimeout(() => {
        this.addingStatus = 'done'
        this.$nextTick(() => {
          ref.blur()
        })
      }, 2000)
    },
    incrementValue () {
      this.item_quantity++
    },
    decrementValue () {
      if (this.item_quantity > 0) {
        this.item_quantity--
      }
    },
    goBack () {
      clearTimeout(this.timer)
      this.$router.push(`/${this.shopId}/store`)
    }
  }
}
</script>

<style scoped>
.caption-full {
  padding-right: 10px;
  padding-left: 10px;
}

.ratings {
  padding-right: 10px;
  padding-left: 10px;
  color: #d17581;
}
.img_bg {
  background-color: var(--dark-color-01);
}
.dark-mode .img_bg {
  background-color: var(--light-color-04);
}
</style>
